// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NKoIE","footer-item":"footer_footer-item__s5tbB"};